
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.016 3.932c.182.159.387.227.614.227a.907.907 0 00.614-1.59L18.062 1.5 16.88.432C16.516.09 15.926.114 15.607.5a.908.908 0 00.069 1.295l.5.455-.91 1.023a9.483 9.483 0 00-3.568-1.637 1.712 1.712 0 00-.363-.909C11.107.41 10.63.045 9.766 0h-.045c-.795 0-1.25.34-1.5.636-.273.319-.386.705-.432 1a9.263 9.263 0 00-7.34 9.069C.448 15.817 4.606 20 9.72 20s9.273-4.16 9.273-9.296c0-2.386-.91-4.568-2.387-6.227l.91-1.022.5.477zM9.721 18.159a7.459 7.459 0 01-7.455-7.454A7.459 7.459 0 019.721 3.25a7.459 7.459 0 017.454 7.454 7.459 7.459 0 01-7.454 7.455zm1.59-7.454c0 .863-.726 1.568-1.59 1.568a1.552 1.552 0 01-1.545-1.569c0-.522.227-1 .681-1.272V5.75c0-.5.41-.91.91-.91s.909.41.909.91v3.682c.454.273.636.75.636 1.272z","fill":"#56BFC7"}})])
          )
        }
      }
    